import { render, staticRenderFns } from "./PokedexView.vue?vue&type=template&id=1993f7fa&scoped=true&"
import script from "./PokedexView.vue?vue&type=script&lang=js&"
export * from "./PokedexView.vue?vue&type=script&lang=js&"
import style0 from "./PokedexView.vue?vue&type=style&index=0&id=1993f7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993f7fa",
  null
  
)

export default component.exports